import { render } from "./detail-international.vue?vue&type=template&id=5e53a0ad&ts=true"
import script from "./detail-international.vue?vue&type=script&lang=ts"
export * from "./detail-international.vue?vue&type=script&lang=ts"

import "./detail-international.vue?vue&type=style&index=0&id=5e53a0ad&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__